function skipConstructorItems(items, data) {
  const filteredConstructorItems = [];
  items.forEach((item) => {
    const isSkipItem = "skipRenderFn" in item && typeof item.skipRenderFn === "function" && item.skipRenderFn(data);
    if (isSkipItem) {
      return;
    }
    const filteredItem = { ...item };
    if ("items" in filteredItem) {
      filteredItem.items = skipConstructorItems(filteredItem.items, data);
    }
    filteredConstructorItems.push(filteredItem);
  });
  return filteredConstructorItems;
}
function skipConstructorLayout(layout, data) {
  if (!layout.items) {
    return layout;
  }
  const resolvedLayout = { ...layout };
  if (Array.isArray(resolvedLayout.items)) {
    resolvedLayout.items = skipConstructorItems(resolvedLayout.items, data);
  }
  return resolvedLayout;
}
export {
  skipConstructorLayout
};
